/**
 * Generated runtime TestId mirror for frontend/src/features/notifications/AdminNotificationLog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AdminNotificationLogTestIds = {
  adminNotificationLog: "admin-notification-log",
  colDate: "col-date",
  colDeliveryStatus: "col-delivery-status",
  colError: "col-error",
  colEventType: "col-event-type",
  colRecipient: "col-recipient",
  colSentAt: "col-sent-at",
  colTitle: "col-title",
  notificationStatusFailed: "notification-status-failed",
  notificationStatusPending: "notification-status-pending",
  notificationStatusSent: "notification-status-sent",
  adminNotificationError: (notification_id: string) => `admin-notification-error-${notification_id}`,
  adminNotificationErrorPrefix: () => "admin-notification-error-" as TestIdPrefix,
  adminNotificationRecipient: (notification_id: string) => `admin-notification-recipient-${notification_id}`,
  adminNotificationRecipientPrefix: () => "admin-notification-recipient-" as TestIdPrefix,
  adminNotificationRow: (notification_id: string) => `admin-notification-row-${notification_id}`,
  adminNotificationRowPrefix: () => "admin-notification-row-" as TestIdPrefix,
  adminNotificationTitle: (notification_id: string) => `admin-notification-title-${notification_id}`,
  adminNotificationTitlePrefix: () => "admin-notification-title-" as TestIdPrefix
} as const;
